import {
    styled,
    FormControl,
    FormHelperText,
    Select,
    MenuItem,
} from "@material-ui/core";
import { brand } from "../../../theme";
import { FormLabel } from "../styles/shared";

export const SecondaryBeerField = styled(({
    beers,
    selectedBeer,
    primaryBeer,
    onChange,
    ...p
}: any) => (
    <FormControl margin="normal" fullWidth {...p}>
        <FormLabel>Reminder Beer · Not scored</FormLabel>
        <div className={`card${selectedBeer ? " card--on" : ""}`}>
            <Select
                className="select"
                value={selectedBeer ?? ""}
                onChange={(e) => onChange((e.target.value as string) || null)}
                displayEmpty
                disableUnderline
                inputProps={{ "data-testid": "secondaryBeer" } as any}
                renderValue={(value) =>
                    value
                        ? <span>{value as string}</span>
                        : <span className="placeholder">Add a backup guess</span>
                }
            >
                {(beers || [])
                    .filter((b: string | null) => b && b !== primaryBeer)
                    .map((b: string) => (
                        <MenuItem key={b} value={b}>{b}</MenuItem>
                    ))}
            </Select>
            {selectedBeer && (
                <button
                    type="button"
                    className="clear"
                    data-testid="secondaryBeer-clear"
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        onChange(null);
                    }}
                >
                    CLEAR
                </button>
            )}
        </div>
        <FormHelperText className="hint">
            A second guess to remind yourself — won't affect your score.
        </FormHelperText>
    </FormControl>
))(({ theme }) => ({
    marginTop: theme.spacing(3),
    "& .card": {
        background: brand.white,
        borderRadius: 12,
        padding: theme.spacing(1, 1, 1, 2),
        boxShadow: "0 1px 4px rgba(26,18,5,0.06)",
        border: `1px dashed ${brand.textDis}`,
        transition: "border-color .2s, background .2s",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    "& .card--on": {
        background: brand.amberLight,
        border: `1px solid ${brand.amber}55`,
    },
    "& .select": {
        flex: 1,
        minWidth: 0,
    },
    "& .placeholder": {
        color: brand.textSec,
        fontStyle: "italic",
    },
    "& .clear": {
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: 11,
        fontWeight: 800,
        color: brand.textSec,
        letterSpacing: 0.6,
        padding: theme.spacing(0.5, 0.75),
        fontFamily: "inherit",
        flexShrink: 0,
    },
    "& .clear:hover": {
        color: brand.text,
    },
    "& .hint": {
        fontSize: 12,
        fontStyle: "italic",
        color: brand.textSec,
        marginTop: theme.spacing(1),
    },
}));
